import { IConfiguration, IOption } from '../Interface/Interface';

export const getSelectedDriveOptionsForRaidSlotConsumerOption = (
  option: IOption,
  configuration: IConfiguration
) => {
  const consumesRaidSlotType = option.attributes.find(({ identifier }) =>
    identifier.startsWith('consumes_slottype_raid_level')
  )?.identifier;
  if (!consumesRaidSlotType) {
    return null;
  }
  const providerSlotType = consumesRaidSlotType.replace(
    'consumes_',
    'provides_'
  );
  const selectedRaidProviderOptions: IOption[] =
    configuration.optionclassifications
      .map(({ selectedoptions }) => selectedoptions as IOption[])
      .flat()
      .filter((option) =>
        option?.attributes.some(
          ({ identifier }) => identifier === providerSlotType
        )
      );
  return {
    selectedRaidProviderOptions
  };
};
